import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';

import { initializeApp } from "firebase/app";
import { initSentry } from './utilities/sentry';

// Fire-and-forget; no-op when DSN/package missing.
initSentry();


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  measurementId: "G-NLETTYGTYN",
};
initializeApp(firebaseConfig);

// Analytics is handled directly in public/index.html via gtag.js with Consent Mode v2.
// Firebase Analytics is intentionally not initialized here to avoid duplicate page_view events.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
<script type="text/javascript" src="https://app.termly.io/embed.min.js" data-auto-block="on"
  data-website-uuid="f598c7ee-7618-4723-935a-a3d5c809d45a"></script>
// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
